export default __webpack_public_path__ + "static/media/whiteCloudFormation.9bd25e32.svg";